/**
 * useFacebookPixel
 * ----------------
 * React hook that wires up PageView tracking on every route change.
 * Import and call once at the top-level component (App.tsx or StorefrontLayout).
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/pixel/metaPixel';

export function useFacebookPixel(): void {
  const location = useLocation();
  const prevPathname = useRef<string | null>(null);

  useEffect(() => {
    // Skip if same path (hash-only changes, etc.)
    if (prevPathname.current === location.pathname + location.search) return;
    prevPathname.current = location.pathname + location.search;

    // Small delay to ensure the page title has updated
    const timer = setTimeout(() => {
      trackPageView();
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);
}
